import React, { useEffect, useState } from "react";
import {
  Alert,
  AppBar,
  Box,
  Container,
  Grid,
  Hidden,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { PropTypes } from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";

//IMPORTS SCREEN COMPONENTS
import CareerStatsDashboard from "./CareerStatsDashboard";
import HistoricalCombineResult from "./HistoricalCombineResult";

//SERVICE CALSS
import { HistoricalCombineResultServices } from "../../services/historicalGroupCombine.Service";
import IndividualCombineResult from "../IndividualGroupComparison/IndividualCombineResult";
import Loader from "../../sharedComponents/loader/loader";

const useStyles = makeStyles((theme) => ({
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  title: {
    flexGrow: 1,
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
}));

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const ComparableDashboard = () => {
  const classes = useStyles();
  const theme = useTheme();

  const [selectedTab, setSelectedTab] = useState(0);

  //HISTORICAL COMBINE RESULT DISPLAY FLAG
  const [isHistoricalGCShow, setIsHistoricalGCShow] = useState("false");

  //... Alert data holders
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");

  //... Loader Data holders
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getHistoricalCombineResultDisplayFlag() {
      const response =
        await HistoricalCombineResultServices.getHistoricalGCDisplayFlag();
      const childName = response?.data?.[0]?.childName;

      setIsHistoricalGCShow(childName);
    }

    //GET HISTORICAL COMBINE RESULT DISLAY ENUMARATION
    getHistoricalCombineResultDisplayFlag();
  }, []);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  //... Utility to show alert.
  const showAlert = (error, type, message) => {
    setAlert(error);
    setAlertType(type);
    setAlertMessage(message);
  };

  return (
    <>
      <Loader isLoading={loading} />
      <AppBar position="static" className={classes.appbarBackground}>
        <Toolbar>
          <Box display="flex">
            <Typography
              noWrap
              variant="h6"
              className={`${classes.title} header-title`}
            >
              Comparable Dashboard
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <Container maxWidth={false}>
        <Grid container pt={2} pb={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container>
              <Grid item lg xs={12}>
                <Paper
                  elevation={8}
                  sx={{
                    borderRadius: "16px",
                  }}
                >
                  <Box
                    component="div"
                    display="flex"
                    flexGrow={1}
                    flexDirection="column"
                    className={classes.paperStyle}
                  >
                    <AppBar
                      position="static"
                      className={classes.appbar}
                      sx={{
                        borderTopLeftRadius: "15px !important",
                        borderTopRightRadius: "15px !important",
                      }}
                    >
                      <Hidden mdUp>
                        <Tabs
                          scrollButtons
                          allowScrollButtonsMobile
                          value={selectedTab}
                          onChange={handleChange}
                          indicatorColor="primary"
                          textColor="inherit"
                          variant="scrollable"
                          aria-label="full width tabs example"
                          // selectionFollowsFocus
                        >
                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Individual Comparison Group"
                            {...a11yProps(0)}
                          />

                          {/* <Tab
                            sx={{
                              textTransform: "none",
                              display:
                                isHistoricalGCShow === "true"
                                  ? "block"
                                  : "none",
                            }}
                            label="Historical Combine Results"
                            {...a11yProps(1)}
                          /> */}

                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Career Stats"
                            {...a11yProps(2)}
                          />
                        </Tabs>
                      </Hidden>
                      <Hidden mdDown>
                        <Tabs
                          scrollButtons
                          allowScrollButtonsMobile
                          value={selectedTab}
                          onChange={handleChange}
                          indicatorColor="primary"
                          textColor="inherit"
                          variant="standard"
                          aria-label="full width tabs example"
                        >
                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Individual Comparison Group"
                            {...a11yProps(0)}
                          />

                          {/* <Tab
                            sx={{
                              textTransform: "none",
                              display:
                                isHistoricalGCShow === "true"
                                  ? "block"
                                  : "none",
                            }}
                            label="Historical Combine Results"
                            {...a11yProps(1)}
                          /> */}

                          <Tab
                            sx={{ textTransform: "none" }}
                            label="Career Stats"
                            {...a11yProps(2)}
                          />
                        </Tabs>
                      </Hidden>
                    </AppBar>
                    <SwipeableViews
                      className={classes.swipeView}
                      axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                      index={selectedTab}
                      onChangeIndex={handleChangeIndex}
                    >
                      <TabPanel
                        value={selectedTab}
                        index={0}
                        dir={theme.direction}
                      >
                        <IndividualCombineResult
                          showAlert={showAlert}
                          loading={loading}
                          setLoading={setLoading}
                        />
                      </TabPanel>
                      {/* <TabPanel
                        value={selectedTab}
                        index={1}
                        dir={theme.direction}
                      >
                        <HistoricalCombineResult showAlert={showAlert} />
                      </TabPanel> */}

                      <TabPanel
                        value={selectedTab}
                        index={1}
                        dir={theme.direction}
                      >
                        <CareerStatsDashboard />
                      </TabPanel>
                    </SwipeableViews>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={3000}
        onClose={() => setAlert(false)}
      >
        <Alert
          onClose={() => setAlert(false)}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ComparableDashboard;
